export default "__VITE_ASSET__DKoZ_cxV__"